import { Divider } from "@mui/material";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { useGetHomePagePartnersQuery } from "../../utils/API/features/strapiHomeApi";
import "./OurPartners.scss";
import CustomLoader from "../Shared/CustomLoader/CustomLoader";
import { CustomLoaderType } from "../../utils/constants";

const OurPartners = ({ style, photosProp }) => {
	const shouldUseStrapi = Boolean(import.meta.env.VITE_STRAPI_URL) && !photosProp;

	const {
		data: strapiPartners = [],
		isLoading,
		isFetching,
		isError,
	} = useGetHomePagePartnersQuery(undefined, {
		skip: !shouldUseStrapi,
	});

	const isBusy = shouldUseStrapi && (isLoading || isFetching);
	const partnersToRender =
		photosProp?.length > 0
			? photosProp.map((src) => ({ src }))
			: !isError && strapiPartners?.length > 0
				? strapiPartners
				: [];

	// If Strapi is enabled and it's still loading, show the section with a loader.
	// If Strapi isn't enabled and no photos were passed, keep old behavior (render nothing).
	if (!isBusy && partnersToRender.length === 0) return null;

	return (
		<div className='partnersComponent' style={style || {}}>
			<Divider />
			<motion.div
				initial={{ opacity: 0 }}
				whileInView={{ opacity: 1 }}
				viewport={{ once: true, amount: 0.8 }}
				transition={{ ease: "easeOut", duration: 0.4 }}
				className='our-partners-wrapper'
			>
				<h1>Our Trusted Partners</h1>

				<div className='logos'>
					{isBusy ? (
						<CustomLoader type={CustomLoaderType.SMALL} />
					) : (
						partnersToRender.map((p, index) =>
							p.href ? (
								<img
									src={p.src}
									alt='brand'
									key={index}
									style={{ cursor: "pointer" }}
									onClick={() => window.open(p.href, "_blank", "noopener,noreferrer")}
								/>
							) : (
								<img src={p.src} alt='brand' key={index} />
							),
						)
					)}
				</div>
			</motion.div>
			<Divider />
		</div>
	);
};

OurPartners.propTypes = {
	style: PropTypes.object,
	photosProp: PropTypes.arrayOf(PropTypes.string),
};

export default OurPartners;
